/*
  Atelierul de Așternuturi — cart reservation timer engine.

  One engine, three surfaces: a countdown beside the bag icon (every page), a
  fixed bar that only appears for the final minutes, and the inline notice on the
  cart page. Keeping it in a single place matters — two copies of this racing each
  other would both POST to /cart/clear.js.

  The deadline lives in localStorage keyed to the cart's item count, so a refresh
  keeps counting while an actual cart change starts a fresh window. Abandoned
  checkouts are untouched: Shopify snapshots those separately the moment a shopper
  enters checkout, so clearing the storefront cart never kills a recovery link.
*/
(function () {
  var cfgEl = document.getElementById('at-cart-timer-config');
  if (!cfgEl) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg.enabled) return;

  var KEY = 'at_cart_deadline';
  var FLAG = 'at_cart_expired';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var count = parseInt(cfg.count, 10) || 0;
  var deadline = null;
  var ticker = null;
  var finished = false;

  var badge = document.querySelector('[data-at-tb]');
  var badgeTime = badge && badge.querySelector('[data-at-tb-time]');
  var badgeM = badge && badge.querySelector('[data-at-tb-m]');
  var badgeS = badge && badge.querySelector('[data-at-tb-s]');
  var bar = document.querySelector('[data-at-bar]');
  var barTime = bar && bar.querySelector('[data-at-bar-time]');
  var toast = document.querySelector('[data-at-toast]');
  // The cart page renders its own inline notice; suppress the fixed bar there.
  var inline = document.querySelector('[data-at-cart-timer]');
  var inlineTime = inline && inline.querySelector('.at-ct__time');

  // The badge is authored at the end of <body>; move it beside the bag icon.
  // If the header markup ever changes, the badge simply stays hidden.
  var bagLink = document.getElementById('cart-icon-bubble');
  if (badge && bagLink && bagLink.parentNode) {
    bagLink.parentNode.insertBefore(badge, bagLink);
  } else if (badge) {
    badge.parentNode.removeChild(badge);
    badge = null;
    badgeTime = null;
  }

  function store(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function read() { try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; } }
  function drop() { try { localStorage.removeItem(KEY); } catch (e) {} }
  function flagSet() { try { sessionStorage.setItem(FLAG, '1'); } catch (e) {} }
  function flagTake() {
    try { var v = sessionStorage.getItem(FLAG); sessionStorage.removeItem(FLAG); return v === '1'; }
    catch (e) { return false; }
  }

  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function label(ms) {
    var t = Math.max(0, Math.ceil(ms / 1000));
    var m = Math.floor(t / 60);
    var r = t % 60;
    return m + ':' + (r < 10 ? '0' : '') + r;
  }

  function hideAll() {
    if (badge) badge.hidden = true;
    if (bar) bar.classList.remove('at-bar--in');
    document.body.classList.remove('at-bar-open');
  }

  function showToast() {
    if (!toast) return;
    toast.hidden = false;
    // A timeout, not requestAnimationFrame: rAF is throttled in background tabs,
    // which left the notice invisible for its whole lifetime.
    setTimeout(function () { toast.classList.add('at-toast--in'); }, 20);
    setTimeout(function () {
      toast.classList.remove('at-toast--in');
      setTimeout(function () { toast.hidden = true; }, 400);
    }, 6000);
  }

  function zeroBagCount() {
    var bubble = document.querySelector('.cart-count-bubble');
    if (bubble && bubble.parentNode) bubble.parentNode.removeChild(bubble);
  }

  function expireNow() {
    if (finished) return;
    finished = true;
    if (ticker) clearInterval(ticker);
    drop();
    hideAll();

    if (inline) {
      var run = inline.querySelector('.at-ct__running');
      var done = inline.querySelector('.at-ct__done');
      if (run) run.hidden = true;
      if (done) done.hidden = false;
      inline.hidden = false;
    }

    if (!cfg.clear) return;

    var onCart = !!inline;
    if (onCart) flagSet();

    fetch(root.replace(/\/$/, '') + '/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: '{}'
    })
      .then(function () {
        if (onCart) { window.location.reload(); return; }
        zeroBagCount();
        showToast();
      })
      .catch(function () { /* leave the cart alone if the request failed */ });
  }

  function paint() {
    var left = deadline - Date.now();
    var text = label(left);

    if (badgeM && badgeS) {
      // Two padded halves so mobile can stack "09" over "59" without a colon.
      var whole = Math.max(0, Math.ceil(left / 1000));
      badgeM.textContent = pad2(Math.floor(whole / 60));
      badgeS.textContent = pad2(whole % 60);
      badge.hidden = false;
    } else if (badgeTime) {
      badgeTime.textContent = text;
      badge.hidden = false;
    }
    if (inlineTime) inlineTime.textContent = text;

    if (bar && !inline && cfg.warnMs > 0) {
      if (left <= cfg.warnMs) {
        if (barTime) barTime.textContent = text;
        bar.classList.add('at-bar--in');
        // Lets the WhatsApp button lift clear of the same corner.
        document.body.classList.add('at-bar-open');
      } else {
        bar.classList.remove('at-bar--in');
        document.body.classList.remove('at-bar-open');
      }
    }

    if (left <= 0) expireNow();
  }

  function start() {
    if (ticker) clearInterval(ticker);
    finished = false;
    ticker = setInterval(paint, 1000);
    paint();
  }

  function sync(n) {
    count = n;

    if (count === 0) {
      drop();
      hideAll();
      if (ticker) clearInterval(ticker);
      if (flagTake() && inline) {
        var run = inline.querySelector('.at-ct__running');
        var done = inline.querySelector('.at-ct__done');
        if (run) run.hidden = true;
        if (done) done.hidden = false;
        inline.hidden = false;
      }
      return;
    }

    var saved = read();
    var sameCart = saved && saved.c === count;

    if (sameCart && saved.d <= Date.now()) {
      // Window lapsed while they were elsewhere. Honour it rather than
      // silently granting a fresh reservation on arrival.
      expireNow();
      return;
    }

    if (sameCart) {
      deadline = saved.d;
    } else {
      deadline = Date.now() + cfg.durationMs;
      store({ d: deadline, c: count });
    }
    start();
  }

  sync(count);

  // The theme rewrites the bag bubble on AJAX add/remove; follow it so the
  // window restarts when the cart actually changes.
  var bagHost = document.getElementById('cart-icon-bubble');
  if (bagHost) {
    new MutationObserver(function () {
      var bubble = bagHost.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      var n = bubble ? parseInt(bubble.textContent.trim(), 10) : 0;
      if (isNaN(n)) n = 0;
      if (n !== count) sync(n);
    }).observe(bagHost, { childList: true, subtree: true, characterData: true });
  }
})();
